/*@flow*/
import geoJSONLayer from 'lib/leaflet-plugins/GeoJSONLayer';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';
import useLayer from '../useLayer';

type GeoJSONT = Object;
type StyleT = Object;
type OptionsT = {
  enabled: boolean,
  url: string,
  style: (geojson: GeoJSONT) => StyleT,
  onEachFeature: (geojson: GeoJSONT, layer: Leaflet$Path) => void,
};

export default (props: DeckPropsT<OptionsT>) => {
  const { options } = props;
  const [element, setElement] = useState();

  useEffect(() => {
    setElement(() => geoJSONLayer(options));
  }, []);

  useLayer<OptionsT>(props, element);
};
